import { forwardRef } from 'react'
import { createEvent } from '@trybeapp/ui.utilities'
import { Select } from '@trybeapp/ui.select'
import { useAllRooms } from 'api/Rooms'

export const RoomSelect = forwardRef(({ ...props }, ref) => {
  const { data: { data: rooms = [] } = {}, isLoading } = useAllRooms()

  if (isLoading) return null

  const options = rooms.map((room) => ({
    value: room.id,
    label: room.name,
  }))

  return <Select options={options} isClearable={true} ref={ref} {...props} />
})

export const FormikRoomSelect = forwardRef(({ onChange: parentOnChange, name, ...props }, ref) => {
  const onChange = (value) => {
    parentOnChange(createEvent({ name, value }))
  }

  return <RoomSelect name={name} onChange={onChange} ref={ref} {...props} />
})
